import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from '@material-ui/core/TextField'
// @material-ui/icons

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// Sections for this page
import ProductSection from "./Sections/ProductSection.jsx";
import TeamSection from "./Sections/TeamSection.jsx";
import Typography from '@material-ui/core/Typography'
import WorkSection from "./Sections/WorkSection.jsx";
import * as firebase from 'firebase/app'
import { generateKeyPair, createHash } from "crypto";

const INITIAL_STATE = {
  name: '',
  email: '',
  message: '',
};

function hashCode(str) {
  return str.split('').reduce((prevHash, currVal) =>
    (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
}

class LandingPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    console.log("We here!");
    console.log(this.state);
    const { name, email, message } = this.state;
    firebase.database().ref('Leads/'+hashCode(name+''+email+''+message)).set({
      name: name,
      email: email,
      message: message
    })
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { classes, ...rest } = this.props;
    const { name, email, message} = this.state;

    const isInvalid = name === '' || email === '' || message === '';
    return (
      <div>
        {/* <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="Material Kit React"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
        /> */}
        <Parallax filter image={require("assets/img/hemp-leaves.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <h1 className={classes.title}>Keep it SMPL</h1>
                <h4>
                  A Blockchain-based software platform that covers the end-to-end production and supply chain operations of producers and processors within the industrial hemp industry
                </h4>
                <br />
                <Button
                  size="lg"
                  href="/SignUp"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: '#4CAF50'
                  }}
                >
                  {/* <i className="fas fa-play" /> */}
                  Sign Up
                </Button>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)} style={{
          paddingRight: '5%',
          paddingleft: '5%'
        }}>
          <div className={classes.container}>
            <ProductSection />
            {/* <TeamSection /> */}
            {/* <WorkSection /> */}

            <div>
              <Typography variant='h3' style={{
                textAlign: 'center',
                paddingBottom: '40px'
              }}
              >Contact us</Typography>
              <div>
                <form onSubmit={this.onSubmit} style={{ 
                  textAlign: 'center',
                  marginRight: '15%',
                  marginLeft: '15%',
                  paddingBottom: '10%'
                  }}>
                  <TextField
                    name="name"
                    value={name}
                    onChange={this.onChange}
                    type="text"
                    fullWidth
                    placeholder="Name"
                    style={{ paddingBottom: '20px' }}
                  />
                  <br></br>
                  <TextField
                    name="email"
                    value={email}
                    onChange={this.onChange}
                    type="text"
                    fullWidth
                    placeholder="Email"
                    style={{ paddingBottom: '20px' }}
                  />
                  <br></br>
                  <TextField
                    name="message"
                    value={message}
                    onChange={this.onChange}
                    multiline
                    fullWidth
                    rows='4'
                    type="text"
                    placeholder="Message"
                    style={{ paddingBottom: '20px'}}
                  />
                  <br></br>
                  <Button disabled={isInvalid} type="submit" style={{
                    backgroundColor: '#4CAF50'
                  }}>
                    Submit
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(landingPageStyle)(LandingPage);
